/**
 * IMPORTS
 */

import { CreditCard } from "lucide-react";

const CardInfo = ({ item }: any) => {
  return (
    <>
      <div className="flex w-64 items-center justify-between rounded-lg bg-white p-4 shadow-md">
        <div className="flex flex-col">
          <span className="text-sm text-gray-500">Créditos</span>
          <span className="text-2xl font-bold text-gray-900">{item?.total ?? "100"}</span>
          <span className="text-md mt-1 font-medium text-gray-900">
            {item?.tipo ?? "Cartão PVC"}
          </span>
        </div>
        <div className="flex items-center">
          <CreditCard size={24} className="text-gray-900" />
        </div>
      </div>
    </>
  );
};

/**
 * EXPORTS
 */
export { CardInfo };
